module.exports = __webpack_public_path__ + "static/lobster-44980c3dfc71b17f50b0ac707b464ccf.svg";